module.exports = __webpack_public_path__ + "img/Insta.174fc3c2.svg";